import { createContext } from "react";

const defaultValue = null;

export const UserContext = createContext(defaultValue);
export const AdminContext = createContext(defaultValue);
